import StarIconFilled from './StarIconFilled';
export default StarIconFilled;
